<template>
    <Modal2
        id="awaiting-message-details"
        :title="`Talep Detay / ${getTicketPlatform()}`"
        :show-footer="false"
        @cancel="closeModal"
    >
        <!-- Güncellenmiş information banner -->
        <div class="information-banner" v-if="ticket.returnType">
            <i class="material-icons">info</i>
            <span v-if="ticket.returnType === 'email' || !ticket.returnType">
                Bu kişi e-posta ile cevaplanmak istiyor
            </span>
            <span v-else-if="ticket.returnType === 'whatsapp'">
                Bu kişi WhatsApp üzerinden cevap bekliyor.
                <a href="javascript:void(0)" @click="showWhatsappChatStarter"
                    >WhatsApp chat başlatmak için tıklayınız</a
                >
            </span>
        </div>

        <div class="ticket-status-wrapper">
            <span>Talep İlerleme Durumu</span>
            <TicketStatusSwitcher
                :currentStatus="ticket.status"
                :statusList="statusList"
                @update-status="(status) => changeTicketStatus(ticket._id, status)"
            />
        </div>

        <div class="user-info-profile" @click="viewContactProfile">
            <div class="profile-header">
                <ContactAvatar
                    :contact="ticket.visitor"
                    :key="ticket.visitor._id"
                    :badge="true"
                    badge-type="visitor-offline"
                />
                <div class="contact-profile-info">
                    <div class="contact-profile-fullname">{{ ticket.visitor.fullname }}</div>
                    <div class="platform-info">
                        <div class="platform-name">
                            <div class="platform-icon-wrapper">
                                <WhatsappIcon
                                    v-if="ticket.visitor.platform === 'whatsapp'"
                                    color="#25D366"
                                    class="option-icon"
                                />
                                <TelegramIcon v-if="ticket.visitor.platform === 'telegram'" class="option-icon" />
                                <MessengerIcon v-if="ticket.visitor.platform === 'messenger'" class="option-icon" />
                                <webIcon v-if="ticket.visitor.platform === 'web'" class="option-icon" color="black;" />
                                <mailIcon v-if="ticket.visitor.platform === 'email'" class="option-icon" />
                                <MetaIcon v-if="ticket.visitor.platform === 'meta-leads'" class="option-icon" />
                                <InstagramIcon
                                    v-if="ticket.visitor.platform === 'instagram'"
                                    class="option-icon"
                                    special-background-mode
                                />
                                {{ getPlatformName() }}
                            </div>
                            <div class="value-item">
                                <i class="material-icons">email</i>
                                {{ getEmailAddress() || "-" }}
                            </div>

                            <div class="value-item" @click.stop="showStartChat">
                                <i class="material-icons">phone</i>
                                {{ getPhoneNumber() || "-" }}
                            </div>
                        </div>
                        <div
                            v-if="ticket.visitor.platform === 'whatsapp'"
                            class="whatsapp-number"
                            @click.stop="showWhatsappChatStarterModal = true"
                        >
                            <a href="javascript:void(0)">{{ ticket.visitor.whatsappNumber }}</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="selectedHistory.type === 'osr'">
            <div class="ticket-message">
                <strong>Talep Mesajı</strong>
                <p>{{ selectedHistory.messages }}</p>
            </div>

            <quill-editor v-model="responseText" :options="editorOption" />
            <a-select v-model="selectedSenderMailId" :defaultValue="null" style="width: 100%">
                <a-select-option :selected="true" value="null">👉Select Email Sender...</a-select-option>
                <a-select-option :key="senderMail.mail" v-for="senderMail of senderMails" :value="senderMail._id">
                    {{ senderMail.mail }}
                </a-select-option>
            </a-select>
            <b-row class="mt-4">
                <b-col md="12">
                    <div v-if="isSupsisMail()" class="mail-warning">
                        <div class="text">
                            {{ "Bu mail adresi ile gönderimlerde maile verilen yanıtları alamazsınız!" }}
                        </div>
                        <div @click="$router.replace('/integrations/mail')" class="link">
                            Mail adresi eklemek için tıklayınız
                        </div>
                    </div>

                    <SupsisButton @click="closeModal" ghost class="float-right">
                        <template>
                            {{ $t("message.cancel") }}
                        </template>
                    </SupsisButton>
                    <SupsisButton
                        @click="sendResponseAndClose"
                        primary
                        :disabled="responseSending"
                        class="float-right mr-2"
                    >
                        <template v-if="!responseSending"> Cevap Gönder ve Ticket'ı Kapat </template>
                        <template v-else>
                            <font-awesome-icon icon="spinner" spin />
                            {{ $t("message.sending") }}...
                        </template>
                    </SupsisButton>
                    <SupsisButton
                        @click="closeTicket"
                        warning
                        :disabled="responseSending"
                        class="float-right mr-2"
                        ghost
                    >
                        Ticket'ı Kapat
                    </SupsisButton>
                </b-col>
            </b-row>
        </div>
        <div v-else-if="selectedHistory.type === 'automation'">
            <div class="ticket-message">
                <strong>Talep Mesajı</strong>
                <p>{{ selectedHistory.ticket.ticketMessage }}</p>
            </div>

            <quill-editor v-model="responseText" :options="editorOption" />
            <a-select v-model="selectedSenderMailId" :defaultValue="null" style="width: 100%">
                <a-select-option :selected="true" value="null">👉Select Email Sender...</a-select-option>
                <a-select-option :key="senderMail.mail" v-for="senderMail of senderMails" :value="senderMail._id">
                    {{ senderMail.mail }}
                </a-select-option>
            </a-select>
            <b-row class="mt-4">
                <b-col md="12">
                    <div v-if="isSupsisMail()" class="mail-warning">
                        <div class="text">
                            {{ "Bu mail adresi ile gönderimlerde maile verilen yanıtları alamazsınız!" }}
                        </div>
                        <div @click="$router.replace('/integrations/mail')" class="link">
                            Mail adresi eklemek için tıklayınız
                        </div>
                    </div>

                    <SupsisButton @click="closeModal" ghost class="float-right">
                        <template>
                            {{ $t("message.cancel") }}
                        </template>
                    </SupsisButton>
                    <SupsisButton
                        @click="sendResponseAndClose"
                        primary
                        :disabled="responseSending"
                        class="float-right mr-2"
                    >
                        <template v-if="!responseSending"> Cevap Gönder ve Ticket'ı Kapat </template>
                        <template v-else>
                            <font-awesome-icon icon="spinner" spin />
                            {{ $t("message.sending") }}...
                        </template>
                    </SupsisButton>
                    <SupsisButton
                        @click="closeTicket"
                        warning
                        :disabled="responseSending"
                        class="float-right mr-2"
                        ghost
                    >
                        Ticket'ı Kapat
                    </SupsisButton>
                </b-col>
            </b-row>
        </div>
        <div v-else>
            <div v-if="ticket.type !== 'form'" style="display: flex; flex-direction: column">
                <div v-if="filteredMessages.length" v-chat-scroll class="waiting-ticket-messages">
                    <MessageList
                        :contextMenuVisable="false"
                        :always-scroll-to-bottom="false"
                        :colors="colors"
                        :messages="getMessages()"
                        :participants="getParticipants()"
                    />
                </div>
                <quill-editor v-model="responseText" :options="editorOption" />
                <a-select
                    v-model="selectedSenderMailId"
                    :defaultValue="null"
                    v-if="!['instagram-comment', 'instagram-mention', 'page-comment', 'trendyol'].includes(ticket.type)"
                >
                    <a-select-option :selected="true" value="null">👉Select Email Sender...</a-select-option>
                    <a-select-option :key="senderMail.mail" v-for="senderMail of senderMails" :value="senderMail._id">
                        {{ senderMail.mail }}
                    </a-select-option>
                </a-select>
                <div class="actions">
                    <a-switch
                        v-if="['instagram-comment'].includes(ticket.type)"
                        name="hidden"
                        v-model="hidden"
                        checked-children="Hidden Comment"
                        un-checked-children="Unhidden Comment"
                    />
                </div>
                <div class="actions">
                    <SupsisButton @click="closeModal" ghost>
                        {{ $t("message.cancel") }}
                    </SupsisButton>

                    <SupsisButton
                        @click="sendResponse"
                        primary
                        :disabled="responseSending"
                        v-if="
                            !['instagram-comment', 'instagram-mention', 'page-comment', 'trendyol'].includes(
                                ticket.type
                            )
                        "
                    >
                        <span v-if="responseSending">
                            <font-awesome-icon icon="spinner" spin />
                            {{ $t("message.sending") }}...
                        </span>
                        <span v-else>{{ $t("message.send") }}</span>
                    </SupsisButton>
                    <SupsisButton
                        @click="() => deleteComment()"
                        danger
                        :disabled="responseSending"
                        v-if="['instagram-comment'].includes(ticket.type)"
                    >
                        <span v-if="responseSending">
                            <font-awesome-icon icon="spinner" spin />
                            Deleting...
                        </span>
                        <span v-else>Delete Comment and Close</span>
                    </SupsisButton>
                    <SupsisButton
                        @click="() => sendAsComment(false)"
                        primary
                        :disabled="responseSending"
                        v-if="['instagram-comment', 'instagram-mention', 'page-comment'].includes(ticket.type)"
                    >
                        <span v-if="responseSending">
                            <font-awesome-icon icon="spinner" spin />
                            {{ $t("message.sending") }}...
                        </span>
                        <span v-else>{{ $t("message.replyAsAComment") }}</span>
                    </SupsisButton>
                    <SupsisButton
                        @click="() => sendAsComment(true)"
                        primary
                        :disabled="responseSending"
                        v-if="['instagram-comment', 'page-comment'].includes(ticket.type)"
                    >
                        <span v-if="responseSending">
                            <font-awesome-icon icon="spinner" spin />
                            {{ $t("message.sending") }}...
                        </span>
                        <span v-else>{{ $t("message.ReplyAsAPm") }}</span>
                    </SupsisButton>

                    <SupsisButton
                        @click="replyTrendyolQuestion"
                        primary
                        :disabled="responseSending"
                        v-if="['trendyol'].includes(ticket.type)"
                    >
                        <span v-if="responseSending">
                            <font-awesome-icon icon="spinner" spin />
                            {{ $t("message.sending") }}...
                        </span>
                        <span v-else>Yanıtı Gönder ve Kapat</span>
                    </SupsisButton>
                </div>
            </div>
            <div v-else-if="ticket.type === 'form'">
                <div class="form-content">
                    <TicketInboxContents :submissionId="ticket.formSubmission" />
                </div>
                <quill-editor v-model="responseText" :options="editorOption" />
                <a-select v-model="selectedSenderMailId" :defaultValue="null" style="width: 100%">
                    <a-select-option :selected="true" value="null">👉Select Email Sender...</a-select-option>
                    <a-select-option :key="senderMail.mail" v-for="senderMail of senderMails" :value="senderMail._id">
                        {{ senderMail.mail }}
                    </a-select-option>
                </a-select>
                <b-row class="mt-4">
                    <b-col md="12">
                        <div v-if="isSupsisMail()" class="mail-warning">
                            <div class="text">
                                {{ "Bu mail adresi ile gönderimlerde maile verilen yanıtları alamazsınız!" }}
                            </div>
                            <div @click="$router.replace('/integrations/mail')" class="link">
                                Mail adresi eklemek için tıklayınız
                            </div>
                        </div>

                        <SupsisButton @click="closeModal" ghost class="float-right">
                            <template>
                                {{ $t("message.cancel") }}
                            </template>
                        </SupsisButton>
                        <SupsisButton
                            @click="sendResponseAndClose"
                            primary
                            :disabled="responseSending"
                            class="float-right mr-2"
                        >
                            <template v-if="!responseSending"> Cevap Gönder ve Ticket'ı Kapat</template>
                            <template v-else>
                                <font-awesome-icon icon="spinner" spin />
                                {{ $t("message.sending") }}...
                            </template>
                        </SupsisButton>
                        <SupsisButton
                            @click="closeTicket"
                            warning
                            :disabled="responseSending"
                            class="float-right mr-2"
                            ghost
                        >
                            Ticket'ı Kapat
                        </SupsisButton>
                    </b-col>
                </b-row>
            </div>
            <div v-else>
                <b-alert show variant="info">{{ $t("message.chatNotFound") }}</b-alert>
            </div>
        </div>

        <Modal2
            v-if="showWhatsappChatStarterModal"
            @cancel="showWhatsappChatStarterModal = false"
            title="WhatsApp Chat Başlat"
            :showFooter="false"
        >
            <WhatsappChatStarter
                :default-phone-number="getPhoneNumber()"
                channel-override
                phone-number-override
                @close="showWhatsappChatStarterModal = false"
                :default-email="ticket.visitor.email"
                :default-name="ticket.visitor.name || ticket.visitor.fullname"
            />
        </Modal2>

        <div class="navigation-buttons">
            <SupsisButton @click="navigate(-1)" ghost>
                <span class="keyboard-shortcut">Ctrl+←</span>
                Önceki
            </SupsisButton>
            <SupsisButton @click="navigate(1)" ghost>
                <span class="keyboard-shortcut">Ctrl+→</span>
                Sonraki
            </SupsisButton>
        </div>
    </Modal2>
</template>
<script>
import Modal2 from "../../../../components/common/Modal2.vue";
import MessageList from "../../../../components/popup-chat/MessageList.vue";
import * as _ from "lodash";
import moment from "moment/moment";
import { toNewMessagesModel } from "../../../../utils/chat";
import SupsisButton from "../../Settings/components/SupsisButton.vue";
import ticket from "../../../../store/modules/ticket";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import VisitorDetail from "../../Visitors/VisitorDetail.vue";
import ContactAvatar from "../../../../components/popup-chat/chat-window/ContactAvatar.vue";
import MessengerIcon from "../../Chatbot/pages/integrations/svg/MessengerIcon.vue";
import TelegramIcon from "../../Chatbot/pages/integrations/svg/TelegramIcon.vue";
import MetaIcon from "../../Chatbot/pages/integrations/svg/MetaIcon.vue";
import WhatsappIcon from "../../Chatbot/pages/integrations/svg/WhatsappIcon.vue";
import InstagramIcon from "../../Chatbot/pages/integrations/svg/InstagramIcon.vue";
import webIcon from "../../Visitors/components/svg/WebIcon.vue";
import WhatsappChatStarter from "../../Integrations/meta-leads/WhatsappChatStarter.vue";
import TicketStatusSwitcher from "./TicketStatusSwitcher.vue";
import TicketInboxContents from "../../Forms/Components/FormInbox/TicketInboxContents.vue";

export default {
    name: "AwaitingTicketDetails",
    components: {
        TicketStatusSwitcher,
        WhatsappChatStarter,
        VisitorDetail,
        SupsisButton,
        ContactAvatar,
        MessageList,
        Modal2,
        MessengerIcon,
        TelegramIcon,
        MetaIcon,
        WhatsappIcon,
        InstagramIcon,
        webIcon,
        TicketInboxContents,
    },
    props: ["ticket", "statusList", "changeTicketStatus"],
    data: () => ({
        showWhatsappChatStarterModal: false,
        responseText: null,
        selectedHistory: {
            visitor: {},
            messages: [],
            ticket: {},
            type: null,
        },
        hidden: false,
        responseSending: false,
        colors: {
            header: {
                bg: "#4e8cff",
                text: "#ffffff",
            },
            launcher: {
                bg: "#4e8cff",
            },
            messageList: {
                bg: "#ffffff",
            },
            sentMessage: {
                bg: "#4e8cff",
                text: "#ffffff",
            },
            receivedMessage: {
                bg: "#eaeaea",
                text: "#222222",
            },
            userInput: {
                bg: "#f4f7f9",
                text: "#565867",
            },
        },
        editorOption: {
            theme: "snow",
            modules: {
                toolbar: [
                    ["bold", "italic", "underline", "strike"],
                    [{ header: [1, 2, 3, 4, 5, 6, false] }],
                    [{ color: [] }, { background: [] }],
                    [{ align: [] }],
                    [{ indent: "-1" }, { indent: "+1" }],
                    ["link"],
                ],
            },
        },
        senderMails: [],
        selectedSenderMailId: null,
    }),
    computed: {
        ...mapGetters({
            getUser: "user/getUser",
        }),
        ...mapState({
            allMailAddresses: (state) => state.mail.allMailAddresses,
            selectedTicketMail: (state) => state.mail.selectedTicketMail,
        }),
        visitorInfo() {
            if (!this.isVisitorExist())
                return {
                    email: "-",
                    fullname: "-",
                };
            if (this.selectedHistory.type === "osr") return this.selectedHistory.ticket.osrPayload;
            if (!!this.selectedHistory.visitor.email && !!this.selectedHistory.visitor.fullname)
                return this.selectedHistory.visitor;
            if (
                !!this.selectedHistory.ticket.conversation &&
                !!this.selectedHistory.ticket.conversation.email &&
                !!this.selectedHistory.ticket.conversation.fullname
            )
                return this.selectedHistory.ticket.conversation;
            return {
                email: "-",
                fullname: "-",
            };
        },
        filteredMessages() {
            return this.selectedHistory.messages.filter((m) => "undefined" === typeof m.type);
        },
    },
    methods: {
        ...mapMutations({
            saveSelectedTicketMail: "mail/saveSelectedTicketMail",
        }),
        ...mapActions({
            loadOldMessages: "chat/loadOldMessages",
            addNewWindow: "app/addNewWindow",
            updateFormStatus: "forms/updateFormStatus",
        }),
        showStartChat(e) {
            if (e) e.stopPropagation();
            if (this.getPhoneNumber()) {
                this.showWhatsappChatStarterModal = true;
            }
        },
        getEmailAddress() {
            return (
                _.get(this.ticket.osrPayload, "email") || this.ticket.visitorEmailAddress || this.ticket.visitor.email
            );
        },
        getPhoneNumber() {
            console.log("this.ticket.visitorPhoneNumber...", this.ticket.visitorPhoneNumber);

            return (
                _.get(this.ticket.osrPayload, "phone") ||
                this.ticket.visitorPhoneNumber ||
                this.ticket.visitor.phoneNumber ||
                this.ticket.visitor.whatsappNumber
            );
        },
        getTicketPlatform() {
            // instagram-comment, instagram-mention, page-comment
            if (this.ticket.type === "instagram-comment") {
                return "Instagram Yorumu";
            } else if (this.ticket.type === "instagram-mention") {
                return "Instagram Bahsetmeleri";
            } else if (this.ticket.type === "page-comment") {
                return "Facebook Sayfa Yorumu";
            } else if (this.ticket.type === "trendyol") {
                return "Trendyol";
            } else if (this.ticket.type === "chatbot") {
                return "Chatbot Üzerinden";
            } else if (!!this.ticket.osrPayload) {
                return "Web Formdan Gelen Talep";
            } else if (this.ticket.type === "form") {
                return "Supsis Formdan Gelen Talep";
            } else if (this.ticket.type === "automation") {
                return "Otomasyon ile Gelen Talep";
            } else {
                return "Chatbot Üzerinden Gelen Talep";
            }
        },
        getPlatformName() {
            const platformMap = {
                whatsapp: "WhatsApp",
                telegram: "Telegram",
                messenger: "Messenger",
                web: "Web",
                email: "Email",
                "meta-leads": "Meta",
                instagram: "Instagram",
                trendyol: "Trendyol",
            };
            return platformMap[this.ticket.visitor.platform] || this.ticket.visitor.platform;
        },
        viewContactProfile() {
            this.addNewWindow({
                type: "show-visitor",
                title: this.ticket.visitor.fullname,
                payload: {
                    visitorId: this.ticket.visitor._id,
                },
                zIndexStart: 1001,
            });
        },
        getTicketTitle() {
            // Ticket Detail of ....
            return `Ticket Details`;
        },
        isSupsisMail() {
            const isExistSupsisMail = (this.senderMails || []).find((x) => x.type === "supsis");
            return this.selectedSenderMailId === isExistSupsisMail?._id;
        },
        closeModal() {
            this.$emit("close");
        },
        sendResponse() {
            const isMetaPlatform = ["instagram-comment", "instagram-mention", "page-comment"].includes(
                this.ticket.type
            );
            const isFormPlatform = this.ticket.type === "form";

            if (this.selectedSenderMailId === "" && !isMetaPlatform) {
                this.$message.error("Please select email sender");
                return;
            }

            this.saveSelectedTicketMail(this.selectedSenderMailId);
            this.$emit("confirm", {
                selectedHistory: this.selectedHistory,
                responseText: this.responseText,
                senderMailId: this.selectedSenderMailId,
            });
            if (isFormPlatform) {
                this.markAsRead();
            }
            this.responseText = "";
        },
        async markAsRead() {
            const siteId = this.ticket.siteId;
            const submissionId = this.ticket.formSubmission;
            await this.updateFormStatus({
                siteId: siteId,
                submissionId: submissionId,
                newStatus: "archive",
            });
        },
        sendResponseAndClose() {
            this.$confirm({
                title: "Cevap Gönder ve Ticket'ı Kapat",
                content: "Cevabı göndermek ve ticket'ı kapatmak istediğinizden emin misiniz?",
                okText: "Evet",
                cancelText: "Hayır",
                onOk: () => {
                    this.$emit("close-ticket", this.ticket._id);
                    this.sendResponse();
                    // this.closeTicket();
                },
            });
        },
        //ard arda iki kere modal uyarısı sorduğu için istek üzerine kapatıldı
        // closeTicket() {
        //     this.$confirm({
        //         title: "Ticket'ı Kapat",
        //         content: "Bu ticket'ı kapatmak istediğinizden emin misiniz? Muhammet ALi Karakaya",
        //         okText: "Evet",
        //         cancelText: "Hayır",
        //         onOk: () => {
        //             this.$emit("close-ticket", this.ticket._id);
        //             this.closeModal();
        //         },
        //     });
        // },
        getMessages() {
            let allMessages = toNewMessagesModel(this.filteredMessages, this);
            if (this.typingMessage) {
                allMessages = [
                    ...allMessages,
                    {
                        type: "typing",
                        data: {
                            text: this.typingMessage,
                        },
                    },
                ];
            }

            return allMessages;
        },
        init() {
            const ticketMessages = JSON.parse(localStorage.getItem("savedTicketMessages") || "{}");
            this.responseText = ticketMessages[this.ticket._id] || "";
            this.selectedHistory.ticket = this.ticket;
            this.selectedHistory.visitor = this.ticket.visitor;
            if (!!this.ticket.osrPayload) {
                this.selectedHistory.messages = this.ticket.osrPayload.message;
                this.selectedHistory.type = "osr";
            } else {
                this.loadOldMessages(this.ticket.conversation?._id).then((response) => {
                    let items = response.data.data;
                    items = _.orderBy(
                        _.uniqBy(items, (q) => q.uniqMessageId || q._id),
                        (q) => moment(q.createdDate).toDate().getTime(),
                        "asc"
                    );
                    this.selectedHistory.messages = items;
                });
                this.selectedHistory.type = this.ticket.type;
            }
        },
        getParticipants() {
            const supportUsers = this.filteredMessages
                .filter((x) => x.messageType === "user" || x.messageType === "private")
                .map((x) => ({
                    id: x.userId,
                    name: x.username,
                }));

            return _.uniqBy(supportUsers, (q) => q.name);
        },
        isVisitorExist() {
            const visitor = _.get(this.selectedHistory, "visitor", {}) || {};
            const visitorKeys = Object.keys(visitor);
            return visitorKeys.length || [].length;
        },
        replyTrendyolQuestion() {
            this.$emit("replyTrendyolQuestion", {
                selectedHistory: this.selectedHistory,
                responseText: this.responseText,
            });
            this.responseText = "";
        },
        sendAsComment(isPrivate = false) {
            this.$emit("sendAsComment", {
                selectedHistory: this.selectedHistory,
                responseText: this.responseText,
                isPrivate,
            });
            this.responseText = "";
        },
        deleteComment() {
            this.$emit("deleteComment", {
                selectedHistory: this.selectedHistory,
                responseText: this.responseText,
            });
            this.responseText = "";
        },
        changeHideStatusIGComment(hide) {
            this.$emit("changeHideStatusIGComment", {
                selectedHistory: this.selectedHistory,
                hide,
            });
        },
        saveLocaleStore: _.debounce(function () {
            const ticketMessages = JSON.parse(localStorage.getItem("savedTicketMessages") || "{}");
            localStorage.setItem(
                "savedTicketMessages",
                JSON.stringify({
                    ...ticketMessages,
                    [this.ticket._id]: this.responseText,
                })
            );
        }, 200),
        navigate(direction) {
            this.$emit("navigate", direction);
        },
        showWhatsappChatStarter() {
            this.showWhatsappChatStarterModal = true;
        },
    },
    watch: {
        responseText() {
            console.log("responseText...", this.responseText);
            this.saveLocaleStore();
        },
        hidden: {
            handler: function (isHidden) {
                if (this.ticket.type === "instagram-comment") {
                    this.changeHideStatusIGComment(isHidden);
                }
            },
            immediate: true,
        },
        ticket: {
            handler() {
                this.init();
            },
            immediate: true,
        },
    },
    mounted() {
        if (!!this.selectedTicketMail) {
            this.selectedSenderMailId = this.selectedTicketMail;
        }
        console.log("this.allMailAddresses...", this.allMailAddresses);
        this.senderMails = this.allMailAddresses.filter(
            (x) => (!!x.isSender && (!!x.isSenderVerified || !!x.isVerified)) || x.type === "supsis"
        );
        this.init();
    },
    beforeDestroy() {
        localStorage.removeItem("savedTicketMessages");
    },
};
</script>

<style lang="scss">
.mail-warning {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 10px;
    background-color: #f0f0f0;
    border-radius: 5px;
    margin-bottom: 10px;

    .text {
        font-size: 14px;
        font-weight: 600;
        color: #ff0000;
    }

    .link {
        font-size: 14px;
        font-weight: 600;
        color: #4e8cff;
        cursor: pointer;
    }
}

#awaiting-message-details {
    .information-banner {
        background-color: #e6f7ff;
        border: 1px solid #91d5ff;
        color: #1890ff;
        padding: 10px;
        margin-bottom: 10px;
        border-radius: 4px;
        font-weight: bold;
        display: flex;
        align-items: center;

        i {
            margin-right: 10px;
        }

        a {
            color: #1890ff;
            text-decoration: underline;
            margin-left: 5px;
            cursor: pointer;

            &:hover {
                color: #40a9ff;
            }
        }
    }

    .ticket-status-wrapper {
        padding: 5px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: white;
    }

    .ticket-message {
        background: white;
        padding: 20px !important;
        border-left: 5px solid pink;
        display: flex;
        flex-direction: column;
        gap: 10px;
    }

    .actions {
        display: flex;
        justify-content: flex-end;
        gap: 10px;
        margin-top: 10px;
    }

    .user-info-profile {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 10px;
        border: 1px solid #f1f4f7;
        border-radius: 8px;
        background-color: #fff;
        cursor: pointer;

        .profile-header {
            display: flex;
            align-items: center;
            gap: 10px;
            width: 100%;

            &:hover {
                .contact-profile-fullname {
                    text-decoration: underline;
                }
            }

            .contact-profile-info {
                display: flex;
                flex-direction: column;
                gap: 5px;
                align-items: flex-start;

                .contact-profile-fullname {
                    font-weight: bold;
                    font-size: 16px;
                }

                .platform-info {
                    display: flex;
                    flex-direction: column;
                    gap: 2px;
                    font-size: 12px;
                    color: #8c8c8c;
                    font-weight: 500;

                    .platform-name {
                        display: flex;
                        gap: 10px;
                        align-items: center;

                        &:hover {
                            cursor: pointer;
                            text-decoration: underline;
                        }

                        .value-item {
                            display: flex;
                            gap: 5px;
                            align-items: center;

                            .material-icons {
                                font-size: 16px;
                            }
                        }
                    }

                    .platform-icon-wrapper {
                        display: flex;
                        gap: 5px;
                        align-items: center;

                        .option-icon {
                            width: 16px;
                            height: 16px;
                        }
                    }

                    .whatsapp-number {
                        cursor: pointer;
                        color: #007bff;
                        text-decoration: underline;
                    }
                }
            }
        }
    }

    .navigation-buttons {
        display: flex;
        justify-content: space-between;
        margin-top: 10px;

        .keyboard-shortcut {
            margin-right: 3px;

            font-size: 0.8rem;
            font-weight: bold;
            color: #000;
            background-color: #f1f1f1;
            padding: 2px 5px;
            border-radius: 5px;
            border: 1px solid #ccc;
            width: max-content;
            height: 19px;
            display: flex;
            justify-content: center;
            align-items: center;
            overflow: hidden;
        }
    }

    .form-content {
        max-height: 500px;
        overflow: scroll;
    }
}
</style>
